import React from 'react';
import Hero from '../components/hero';

export default ({ data }) =>
  <Hero>
    <div dangerouslySetInnerHTML={{ __html: data.contentfulSection.content.childMarkdownRemark.html }} />
  </Hero>

export const query = graphql`
  query portfolioQuery {
    contentfulSection(contentfulid: {eq: "portfolio"}) {
      content {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/portfolio.js